import request from '@/utils/request'

let GradeprofitsApi = {
    /*列表*/
    getProduct(data) {
        return request._get('/shop/plus.gradeprofits.product/index', data);
    },
    /*添加*/
    addProduct(data) {
        return request._post('/shop/plus.gradeprofits.product/add', data);
    },
    /*编辑*/
    editProduct(data) {
        return request._post('/shop/plus.gradeprofits.product/edit', data);
    },
    /*删除*/
    delProduct(data) {
        return request._post('/shop/plus.gradeprofits.product/delete', data);
    },
    /*获取设置*/
    getSetting(data) {
        return request._get('/shop/plus.gradeprofits.setting/index', data);
    },
    /*保存设置*/
    saveSetting(data) {
        return request._post('/shop/plus.gradeprofits.setting/index', data);
    },

}

export default GradeprofitsApi;



// WEBPACK FOOTER //
// ./src/api/gradeprofits.js